import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { MesangemService } from '../../services/mensagem.service';
import { ListaFeirasMensagem, ListaMensagem } from '../../models/mensagem.model';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalAdicionarMensagemComponent } from '../modal-adicionar-mensagem/modal-adicionar-mensagem.component';

@Component({
  selector: 'app-client-messages',
  templateUrl: './client-messages.component.html',
  styleUrl: './client-messages.component.scss'
})
export class ClientMessagesComponent implements OnInit {
  private feirsSubscription: Subscription = new Subscription();
  private mensagensSubscription: Subscription = new Subscription();
  listaFeiras: ListaFeirasMensagem[] = [];
  listaMensagens: any[] = [];

  loading: boolean = false;
  historicoMensagemIdSelecionado: string = '';
  
  constructor(
    private route: ActivatedRoute,
    private mesangemService: MesangemService,
    private location: Location,
    private modalService: NgbModal) {}

  ngOnInit(): void {

    let clienteId = this.route.snapshot.paramMap.get('id');
    this.consultarListaFeiras(clienteId!);
  }

  onFeiraSelecionada(event: Event) {
    const historicoMensagemId = (event.target as HTMLSelectElement).value;
    
    if (!historicoMensagemId) {
      this.historicoMensagemIdSelecionado = '';
      return;
    }

    this.historicoMensagemIdSelecionado = historicoMensagemId;
    let clienteId = this.route.snapshot.paramMap.get('id');

    if (historicoMensagemId) {
      this.loading = true;
      this.consultarListaMensagens(clienteId!, historicoMensagemId);
    }
  }

  consultarListaFeiras(clienteId:string): void {
    this.loading = true;

    this.feirsSubscription = this.mesangemService.consultaListaDeFeiras(clienteId).subscribe({
      next: (response) => {
        this.listaFeiras = response;
      },
      error: (error) => {
        console.error(error);
      },
      complete: () => {
        this.loading = false;
      }
    })
  }

  consultarListaMensagens(clienteId:string, historicoMensagemId:string): void {

    this.mensagensSubscription = this.mesangemService.consultaListaDeMensagensFeiras(clienteId, historicoMensagemId)
    .subscribe({
      next: (response) => {
        this.listaMensagens = response;
      },
      error: (error) => {
        console.error(error);
      },
      complete: () => {
        this.loading = false;
      }
    })
  }

  voltar() {
    this.location.back();
  }

  abrirModalAdicionarMensagem(): void {
    const clienteId = this.route.snapshot.paramMap.get('id');
    
    if (!clienteId) {
      return;
    }

    const modalRef = this.modalService.open(ModalAdicionarMensagemComponent);
    modalRef.componentInstance.clienteId = clienteId;

    modalRef.result.then((result) => {
      if (result && this.historicoMensagemIdSelecionado) {
        // Recarregar a lista de mensagens se houver uma feira selecionada
        this.consultarListaMensagens(clienteId, this.historicoMensagemIdSelecionado);
      }
    }).catch(() => {
      // Modal foi fechado sem salvar
    });
  }
}
